import { z } from 'zod'

/** Token counters. All are non-negative integers; absent reads as 0 server-side. */
export const usageTotalsSchema = z.object({
  runs: z.number().int().nonnegative(),
  api_calls: z.number().int().nonnegative(),
  input_tokens: z.number().int().nonnegative(),
  output_tokens: z.number().int().nonnegative(),
  cache_read_tokens: z.number().int().nonnegative(),
  cache_write_tokens: z.number().int().nonnegative(),
  reasoning_tokens: z.number().int().nonnegative(),
  total_tokens: z.number().int().nonnegative(),
})

export const usageBucketSchema = usageTotalsSchema.extend({
  /** ISO date for the start of the day/week/month bucket. */
  bucket: z.string(),
})

/**
 * `configured: false` means usage tracking is switched off, which is not the
 * same as "nothing spent yet" — the UI must not draw a meter for it.
 */
export const usageSummarySchema = z.object({
  configured: z.boolean(),
  range: z.object({ since: z.string(), until: z.string() }),
  totals: usageTotalsSchema,
  series: z.array(usageBucketSchema),
})
